var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"part-search__result-image-link",class:{
        'd-flex justify-content-center align-items-center': _vm.couldNotLoadImage,
    },attrs:{"href":_vm.href}},[_c('img',{staticClass:"card-img-top part-search__result-image",class:{
            'part-search__result-image--not-found': _vm.couldNotLoadImage,
        },attrs:{"srcset":_vm.couldNotLoadImage
                ? ''
                : ((_vm.getUrlForImage(
                      _vm.src,
                      true,
                      500
                  )) + " 500w, " + (_vm.getUrlForImage(_vm.src, true, 750)) + " 750w"),"sizes":"(max-width: 767px) 750px,\n           (max-width: 1500px) 500px,\n           500px","src":_vm.couldNotLoadImage
                ? '/images/broken-image.svg'
                : ("" + (_vm.getUrlForImage(_vm.src, true, 500))),"alt":_vm.alt},on:{"~error":function($event){return _vm.imageLoadError($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }